import { render, staticRenderFns } from "./lawofflatserve.vue?vue&type=template&id=48368900&scoped=true&"
import script from "./lawofflatserve.vue?vue&type=script&lang=js&"
export * from "./lawofflatserve.vue?vue&type=script&lang=js&"
import style0 from "./lawofflatserve.vue?vue&type=style&index=0&id=48368900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48368900",
  null
  
)

export default component.exports